import { render, staticRenderFns } from "./AddAttrSpec.vue?vue&type=template&id=1a1261f4&scoped=true"
import script from "./AddAttrSpec.vue?vue&type=script&lang=js"
export * from "./AddAttrSpec.vue?vue&type=script&lang=js"
import style0 from "./AddAttrSpec.vue?vue&type=style&index=0&id=1a1261f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1261f4",
  null
  
)

export default component.exports